<template>
  <div ref="mapView" style="height: 100vh"></div>
</template>

<script>
// import { Map, MapView } from '@arcgis/core';
// import { read } from '@arcgis/core/portal/support/mixins/PortalItemMixin';

export default {
  methods: {
    // createMapView() {
    //   const viewContainer = this.$refs.mapView;
    //   this.view = new MapView({
    //     container: viewContainer,
    //     map: this.map
    //   });
    // }
  },
  created() {
    // const mxdUrl = '/static/map/mxd/西藏自治区地图政区简图版A4.mxd';
    // read({ url: mxdUrl }).then(map => {
    //   this.map = map;
    //   this.createMapView();
    // });
  }
};
</script>

<style></style>
